import React from 'react';
import { ChannelCallback } from './ChannelCallback';

/** /auth/twitter/callback — the shared sign-in callback (ChannelCallback) for Twitter. */
const TwitterCallback: React.FC = () => <ChannelCallback platform="twitter" />;

export default TwitterCallback;
